export const rules = {
  data() {
    return {
      required: (v) => !!v || v == "0" || "This field is required.",
      requiredNotAllowZero: (v) => !!v || "This field is required.",
      number: (v) => !v || /^[1-9]\d*$/.test(v) || "Invalid format.",
      currency: (v) =>
        !v ||
        /^([-+]?[1-9][0-9]{0,2}(,[0-9]{3})*(\.[0-9]{0,2})?|[-+]?[1-9][0-9]{0,}(\.[0-9]{0,2})?|[-+]?0(\.[0-9]{0,2})?|[-+]?(\.[0-9]{1,2})?)$/.test(
          v
        ) ||
        "Invalid format.",
      percent: (v) =>
        !v ||
        /(^[-]?100(\.0{1,3})?$)|(^[-]?([1-9]([0-9])?|0)(\.[0-9]{1,3})?$)/g.test(
          v
        ) ||
        "Invalid format.",
      point: (v) => !v || /^[+-]?\d+(\.\d+)?$/g.test(v) || "Invalid format.",
      zipcode: (v) =>
        !v ||
        /^\d{5}$|^\d{5}-\d{4}$/.test(v) ||
        "Invalid format. (ex. 12345 or 12345-6789)",
      ssn: (v) =>
        !v ||
        /^(\d{3}-\d{2}-\d{4}|\d{9})$/.test(v) ||
        "Invalid format. (ex. 123456789 or 123-45-6789)",
      letter: (v) => !v || /^(\s*|[a-zA-Z\s])*$/.test(v) || "Invalid format.",
      email: (v) =>
        !v ||
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
        "Incorrect formatting: Typos, syntax errors, or missing an @ symbol.",
      phone: (v) =>
        !v ||
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
        "Invalid format.",
      creditScore: (v) =>
        !v ||
        (v >= 400 && v <= 850) ||
        "Credit Score must be between 400 and 850.",
      mmddyyyy: (v) =>
        !v ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) ||
        "Invalid format. (MM/DD/YYYY)",
      mmddyyyyhhss: (v) =>
        !v ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2} (20|21|22|23|[0-1]?\d):[0-5]?\d$/.test(
          v
        ) ||
        "Invalid format. (MM/DD/YYYY)",
      cencusTract: (v) =>
        !v || /^\d+\.\d{2,}$/.test(v) || "Invalid format. (e.g. 0000.00)",
      duCaseFileId: (v) =>
        !v ||
        /^\d{10}$/.test(v) ||
        "Invalid pattern. The DU Case File Id should consist of exactly 10 digits.",
      min6: (v) => v.length >= 6 || "Please enter at least 6 characters.",
      max50: (v) => v.length <= 50 || "Please enter than 50 characters",
      nonZeroAmountRegex: (v) =>
        /^(?!0+(\.0+)?$)((\d{1,3}(,\d{3})*|\d+)(\.\d*[1-9])?|0?\.\d*[1-9]\d*)$/.test(
          v
        ) || "Please enter a number that is 0 or higher.",
    };
  },
};

export const common = {
  methods: {
    getValueByKey(keyValuePair, key) {
      return (
        keyValuePair.find((x) => x.key === key)?.displayName ?? "Undefined"
      );
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    openPdfNewTabWithBase64(base64PdfData, title) {
      // base64 데이터를 디코딩하여 바이너리 데이터로 변환
      const binaryPdf = atob(base64PdfData);

      // 바이너리 데이터를 Uint8Array로 변환
      const bytes = new Uint8Array(binaryPdf.length);
      for (let i = 0; i < binaryPdf.length; i++) {
        bytes[i] = binaryPdf.charCodeAt(i);
      }

      // PDF를 보여줄 객체 생성
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      // 새로운 작은 윈도우 창 열기
      const newWindow = window.open("", "_blank", "width=400,height=600");
      newWindow.document.title = `${title}`;

      // 새로운 작은 윈도우 창에 PDF를 보여줄 <embed> 요소 추가
      const pdfEmbed = document.createElement("embed");
      pdfEmbed.src = url;
      pdfEmbed.width = "100%";
      pdfEmbed.height = "100%";
      newWindow.document.body.appendChild(pdfEmbed);
    },
    downloadFileWithUrl(dataurl, fileName, extension) {
      const element = document.createElement("a");
      element.setAttribute("href", dataurl);
      element.setAttribute("download", `${fileName}.${extension}`);
      // element.setAttribute('target', '_blank');
      element.click();
    },
    downloadFile(sourceName, sourceExtension, base64) {
      const element = document.createElement("a");
      const fileName = `${sourceName}.${sourceExtension}`;

      element.setAttribute(
        "href",
        `data:application/octet-stream;base64,${encodeURIComponent(base64)}`
      );
      element.setAttribute("download", fileName);
      element.click();
    },
    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      return new Blob([byteArray], { type: mimeType });
    },
    downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    toFullAddress(street1, city, state, zip) {
      if (street1) {
        return `${street1}, ${city}, ${state} ${zip}`;
      } else {
        return null;
      }
    },
    getPrincipalAndInterest(loanAmt, term, interestRate, isInterestOnly) {
      const myLoanAmt = parseFloat(
        loanAmt.toString().replaceAll(",", "").replaceAll("$", "")
      );
      const myRate = parseFloat(
        (interestRate / 1200).toString().replaceAll(",", "").replaceAll("$", "")
      );
      const myTerm = parseInt(term);

      if (isInterestOnly) {
        return myLoanAmt * (interestRate / 1200.0);
      }

      if (myTerm == 0) {
        return myLoanAmt / myRate;
      }

      return (
        (myLoanAmt * (myRate * Math.pow(1 + myRate, myTerm))) /
        (Math.pow(1 + myRate, myTerm) - 1)
      );
    },
    getNameOnReport(application) {
      if (!application) return null;

      if (application.coBorrower != null) {
        if (application.borrower.lastName == application.coBorrower.lastName) {
          return `${application.borrower.firstName} and ${application.coBorrower.firstName} ${application.borrower.lastName}`;
        }
        return `${application.borrower.firstName} ${application.borrower.lastName} and ${application.coBorrower.firstName} ${application.coBorrower.lastName}`;
      }

      return `${application.borrower.firstName} ${application.borrower.lastName}`;
    },
  },
};

export const convert = {
  methods: {
    toDisplayName(keyValuePair, key) {
      if (keyValuePair && key && keyValuePair.some((x) => x.key === key)) {
        return keyValuePair.find((x) => x.key === key).displayName;
      } else {
        return "";
      }
    },
    toParseInt(val) {
      return val === undefined || val === null
        ? null
        : parseInt(val.toString());
    },
    toParseFloat(val) {
      return val === undefined || val === null
        ? null
        : parseFloat(val.toString().replaceAll(",", "").replaceAll("$", ""));
    },
    toString(val) {
      return val === undefined || val === null ? val : val.toString();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    getNegativePositiveColor(val) {
      return val >= 0 ? "" : "error--text";
    },
    getAvataaars(index) {
      const gravity = 3;
      if (index % gravity == 0) {
        return "https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown";
      } else if (index % gravity == 1) {
        return "https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Black&eyeType=Default&eyebrowType=FlatNatural&mouthType=Default&skinColor=Tanned";
      } else {
        return "https://avataaars.io/?avatarStyle=Circle&topType=LongHairMiaWallace&accessoriesType=Sunglasses&hairColor=BlondeGolden&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Surprised&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Pale";
      }
    },
    getIndexColor(index) {
      const gravity = 4;
      switch (index % gravity) {
        case 0:
          return "secondary";
        case 1:
          return "info";
        case 2:
          return "success";
        case 3:
          return "error";
        default:
          return "default";
      }
    },
    toClosingCostRequestModel(closingCosts) {
      let clonedClosingCosts = JSON.parse(JSON.stringify(closingCosts)); // Deep clone

      for (let i = 0; i < clonedClosingCosts.length; i++) {
        clonedClosingCosts[i].borrowerAmount = this.toParseFloat(
          clonedClosingCosts[i].borrowerAmount
        );
        clonedClosingCosts[i].points = this.toParseFloat(
          clonedClosingCosts[i].points
        );
      }

      return clonedClosingCosts;
    },
    toPrepaidItemRequestModel(prepaidItems) {
      let clonedPrepaidItems = JSON.parse(JSON.stringify(prepaidItems)); // Deep clone

      for (let i = 0; i < clonedPrepaidItems.length; i++) {
        clonedPrepaidItems[i].payment = this.toParseFloat(
          clonedPrepaidItems[i].payment
        );
      }

      return clonedPrepaidItems;
    },
    toOriginTypeFileData(fileData) {
      if (!fileData) {
        return fileData;
      }
      let clonedFileData = JSON.parse(JSON.stringify(fileData)); // Deep clone
      clonedFileData.fileCreditScore = this.toParseInt(
        clonedFileData.fileCreditScore
      );
      clonedFileData.estimatedCreditScore = this.toParseInt(
        clonedFileData.estimatedCreditScore
      );

      if (clonedFileData.transmittal) {
        clonedFileData.transmittal.repCreditScore = this.toParseInt(
          clonedFileData.transmittal.repCreditScore
        );
      }

      if (clonedFileData.subProp) {
        clonedFileData.subProp.appraisedValue = this.toParseFloat(
          clonedFileData.subProp.appraisedValue
        );
      }

      if (clonedFileData.loan) {
        clonedFileData.loan.baseLoan = this.toParseFloat(
          clonedFileData.loan.baseLoan
        );
        clonedFileData.loan.intRate = this.toParseFloat(
          clonedFileData.loan.intRate
        );
        clonedFileData.loan.ltv = this.toParseFloat(clonedFileData.loan.ltv);
        clonedFileData.loan.cltv = this.toParseFloat(clonedFileData.loan.cltv);
        clonedFileData.loan.purPrice = this.toParseFloat(
          clonedFileData.loan.purPrice
        );
        clonedFileData.loan.dti = this.toParseFloat(clonedFileData.loan.dti);

        if (clonedFileData.loan.refiPurpAu == null) {
          clonedFileData.loan.refiPurpAu = 0;
        }

        if (clonedFileData.loan.refiTypeFha == null) {
          clonedFileData.loan.refiTypeFha = 0;
        }

        if (clonedFileData.loan.refiTypeVa == null) {
          clonedFileData.loan.refiTypeVa = 0;
        }

        if (clonedFileData.loan.closingCosts) {
          for (let i = 0; i < clonedFileData.loan.closingCosts.length; i++) {
            clonedFileData.loan.closingCosts[i].borrowerAmount =
              this.toParseFloat(
                clonedFileData.loan.closingCosts[i].borrowerAmount
              );
            clonedFileData.loan.closingCosts[i].points = this.toParseFloat(
              clonedFileData.loan.closingCosts[i].points
            );
          }
        }

        if (clonedFileData.customFields) {
          clonedFileData.customFields.field04 = this.toString(
            clonedFileData.customFields.field04
          );
        }
      }

      if (clonedFileData.relatedLoans) {
        clonedFileData.relatedLoans.forEach((loan) => {
          loan.balanceAtClosing = this.toParseFloat(loan.balanceAtClosing);
        });
      }

      if (clonedFileData.pricingOptions) {
        // TODO...
      } else {
        clonedFileData.pricingOptions = null;
      }

      return clonedFileData;
    },
    toCurrency(number) {
      if (isNaN(number)) {
        return ""; // Nan일 경우 빈 문자열 반환
      }

      const locale = "en-US";
      const options = {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      };

      const formattedNumber = new Intl.NumberFormat(locale, options).format(
        number
      );
      return formattedNumber;
    },
    toPercentage(number) {
      if (isNaN(number)) {
        return ""; // Nan일 경우 빈 문자열 반환
      }
      const percentage = number * 100;
      const formattedPercentage = percentage.toLocaleString("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
      });
      return formattedPercentage;
    },
    toPoints(number) {
      if (isNaN(number)) {
        return ""; // Nan일 경우 빈 문자열 반환
      }
      const percentage = number / 100.0;
      const formattedPercentage = percentage.toLocaleString("en-US", {
        style: "percent",
        minimumFractionDigits: 3,
      });
      return formattedPercentage;
    },
    formatSSN(ssn) {
      // Remove any non-digit characters from the input
      const cleanSSN = ssn.replace(/\D/g, "");

      // Ensure the cleaned SSN is of the correct length
      if (cleanSSN.length !== 9) {
        return ssn + "(Invalid SSN)";
      }

      // Format the SSN into groups of three digits
      const formattedSSN = cleanSSN.replace(
        /(\d{3})(\d{2})(\d{4})/,
        "$1-$2-$3"
      );

      return formattedSSN;
    },
  },
};

export const checker = {
  methods: {
    checkNumber(x) {
      // check if the passed value is a number
      if (
        (typeof x == "number" ||
          typeof x == "string" ||
          typeof x == "object") &&
        !isNaN(x)
      ) {
        // check if it is integer
        if (x == null || x == undefined || x.length === 0) {
          return false;
        } else if (Number.isInteger(x)) {
          return true;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isNullOrEmpty(val) {
      return val === undefined || val === null || val === "";
    },
    validateEmail(email) {
      return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      );
    },
    isRetail(originationChannel) {
      return originationChannel == 1;
    },
    isTPO(originationChannel) {
      return originationChannel == 3;
    },
    isMiniCorr(originationChannel) {
      return originationChannel == 4;
    },
    isCorr(originationChannel) {
      return originationChannel == 5;
    },
  },
};
